import Cookies from "js-cookie";

class Cookie extends Cookies {
  static setDefaults(defaults) {
    Cookies.defaults = defaults;
  }

  static getAllCookie() {
    return this.get();
  }
  static clearAllCookie() {
    let cookies = this.get();
    for (let i in cookies) {
      this.remove(i);
      this.remove(i,{domain: document.domain.split('.').slice(-2).join('.')})
      this.remove(i,{domain: location.hostname})
    }
  }
}

Cookie.getCookie = Cookie.get;
Cookie.setCookie = Cookie.set;
Cookie.clearCookie = Cookie.remove;

export { Cookie as default };
